import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HospitalsComponent } from './hospitals/hospitals.component';
import { SuperadminComponent } from './superadmin.component';

const routes : Routes = [
    {
        path: '',
        component: SuperadminComponent,
        data: {
            title: 'Super Admin Dashboard'
        }
    }, {
        path: 'institutions',
        component: HospitalsComponent,
        data: {
            title: 'Institutions'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SuperadminRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/modules/superadmin/superadmin-routing.module.ts